<button class="przycisk-ikona" [mmIkonaSvg]="ikona" [matTooltip]="label" attr.aria-label="{{label}}"
  [matTooltipPosition]="labelPosition!" [ngClass]="[typ]" [style.padding]="padding"
  [style.padding-left]="paddingX || padding" [style.padding-right]="paddingX || padding"
  [style.padding-top]="paddingY || padding" [style.padding-bottom]="paddingY || padding" [tabindex]="tabIndex"
  [class.disabled]="disabled" (click)="onClick.emit($event)">
</button>
